import { ReportingShellControllerBaseConfig } from '../../../base';
import { ChatCreateController } from './chatCreateInterface';
import { ChatCreateViewProps } from './chatCreateProps';
import { ChatCreateAggregate } from './chatCreateModel';

const MAX_HISTORY_ITEMS = 5;

export function createChatCreateController(
    config: ReportingShellControllerBaseConfig
): ChatCreateController {
    const {
        kernel: {
            infra: { formatter },
        },
    } = config;
    return {
        useProps(context, item, props): ChatCreateViewProps {
            return {
                composer: {
                    onSubmit: props.onSubmit,
                    thread: null,
                },
                history:
                    item.history.length === 0
                        ? null
                        : {
                              label: 'Previous chats',
                              items: item.history
                                  .slice(0, MAX_HISTORY_ITEMS)
                                  .map((thread) => {
                                      const timestamp = formatter.timeago(
                                          thread.createdAt,
                                          {
                                              notation: 'short',
                                          }
                                      );
                                      return {
                                          id: thread.id,
                                          label: thread.title,
                                          timestamp: {
                                              relative: timestamp
                                                  .toLowerCase()
                                                  .includes('now')
                                                  ? timestamp
                                                  : [timestamp, 'ago'].join(' '),
                                          },
                                          button: {
                                              onClick() {
                                                  props.onOpen(thread);
                                              },
                                          },
                                      };
                                  }),
                          },
            };
        },
    };
}
